module.exports = __webpack_public_path__ + "img/youtube_logo.0326e81c.png";